I18n.translations || (I18n.translations = {});
I18n.translations["de"] = I18n.extend((I18n.translations["de"] || {}), {
  "discover": {
    "categories": {
      "index": {
        "all_categories": "Alle Kategorien",
        "all_locations": "Alle Orte",
        "all_projects_about": " ",
        "filter_bar_parts": {
          "for": "für",
          "found": "gefunden",
          "in": "in",
          "projects": "Projekte",
          "with": "mit"
        },
        "find_your_project": "Finde ein Projekt, das zu dir passt!",
        "in_my_region": "Projekte aus meiner Region",
        "location_input_hint": "Einen Ort suchen",
        "moar": "Weitere Projekte anzeigen",
        "no_result_hint": "Für diese Auswahl gibt es keine Ergebnisse. Bitte ändere Kategorie oder Ort um spannende Projekte zu finden.",
        "page_title": "Projekte entdecken auf betterplace.org – Zeit und Geld spenden und Hilfsprojekte unterstützten",
        "projects_about": "Projekte für",
        "search": {
          "placeholder_text": "Stichwortsuche (optional)"
        },
        "search_by_location": "Nach Orten suchen",
        "top_projects_headline": "Was anderen gefällt"
      }
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "discover": {
    "categories": {
      "index": {
        "all_categories": "All categories",
        "all_locations": "All Locations",
        "all_projects_about": " ",
        "filter_bar_parts": {
          "for": "for",
          "found": "found",
          "in": "in",
          "projects": "projects",
          "with": "with"
        },
        "find_your_project": "Find a project that fits you!",
        "in_my_region": "Projects in my region",
        "location_input_hint": "Search for a location",
        "moar": "Show more projects",
        "no_result_hint": "There are no results for this search. Please change category or city to find interesting projects.",
        "page_title": "Discover projects at betterplace.org – Donate time or money to support aid projects around the world",
        "projects_about": "projects about",
        "search": {
          "placeholder_text": "Search term (optional)"
        },
        "search_by_location": "Search by location",
        "top_projects_headline": "Most popular projects"
      }
    }
  }
});
